// PrivacyPolicy.jsx (updated with IRYAX HIRE)
import React from "react";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-4xl mx-auto p-6 sm:p-8"
    >
      <h1 className="text-2xl font-bold text-center mb-2">Privacy Policy</h1>
      <p className="text-center text-sm text-gray-500 mb-8">
        IRYAX HIRE • Last Updated: July 2026
      </p>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <p>
          <strong>Your privacy matters to us.</strong> This Privacy Policy explains how IRYAX HIRE collects, uses, and protects your personal information.
        </p>

        <div>
          <h2 className="text-lg font-semibold mb-2">1. Information We Collect</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Full name, email address, phone number</li>
            <li>Resume/CV, work experience, education details</li>
            <li>Government IDs (Aadhaar, etc.)</li>
            <li>Job applications, assessment results, interview participation</li>
            <li>Coins earned and referral activity</li>
            <li>Payment information for coin purchases</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">2. How We Use Your Information</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Process job applications and match candidates with openings</li>
            <li>Send interview invites, status updates, and notifications</li>
            <li>Process coin purchases and refunds</li>
            <li>Improve platform features and user experience</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">3. Data Security</h2>
          <p>
            We use industry-standard security measures including encryption and secure servers to protect your data. However, no internet transmission is 100% secure.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">4. Your Rights</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Access your personal data</li>
            <li>Request data correction</li>
            <li>Delete your account and data</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">5. Contact Us</h2>
          <p>Email: info@ingrainsystem.com</p>
          <p>Phone: +91-9010481048</p>
        </div>

        <div className="border-t pt-4 mt-4 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} IRYAX HIRE • All Rights Reserved
        </div>
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;